import script from "./shitiduotiao.vue?vue&type=script&setup=true&lang=js"
export * from "./shitiduotiao.vue?vue&type=script&setup=true&lang=js"

import "./shitiduotiao.vue?vue&type=style&index=0&id=bbec6970&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbec6970"]])

export default __exports__